// /* global __DEV__  */
import React, { Fragment } from 'react'
// @material-ui/core components
import withStyles from '@material-ui/core/styles/withStyles'
import FormLabel from '@material-ui/core/FormLabel'
import TextField from '@material-ui/core/TextField'
import MomentUtils from '@date-io/moment'
import { MuiPickersUtilsProvider, DatePicker } from '@material-ui/pickers'
// material ui icons
import LocalLibrary from '@material-ui/icons/LocalLibrary'

// core components
import GridContainer from 'components/Grid/GridContainer.jsx'
import GridItemCondense from 'components/Grid/GridItemCondense.jsx'
import GridItem from 'components/Grid/GridItem.jsx'
import Card from 'components/Card/Card.jsx'
// import CardContent from 'components/Card/CardContent'
import CardBody from 'components/Card/CardBody.jsx'
import CardHeader from 'components/Card/CardHeader.jsx'
import CardIcon from 'components/Card/CardIcon.jsx'
import CardActions from '@material-ui/core/CardActions'
// should change the name to ...condense as well
import CustomInputCondense from 'components/CustomInput/CustomInputCondense'
import CustomMoneyInput from 'components/CustomInput/CustomMoneyInput'
import DropdownUsers from '../Components/DropdownUsers'
import Button from 'components/CustomButtons/Button.jsx'

import ReactToPrint from 'react-to-print'

import { isEmpty, pick } from 'lodash'
// style for this view
import requestSubContractorPayment from '../../assets/jss/material-dashboard-pro-react/views/requestSubContractPayment'

import AppContext from '../../services/context'

// general api service
import {
  insertOne,
  updateOne,
  retrieveDataUsingGraphQL,
  retrieveBoundPath,
  signerResolver,
  getLastLevelOfSingerBasedUponWeight,
  handleApprove,
  handleReject,
  submitApplication,
  isUserInGroup,
  getLastSignerForTOABTA,
} from '../../services/generalServiceAPI'

import Signer from './Signer'
import {
  jsonPP,
  logger,
  titleCase,
  isShowActionButtons,
  isShowSaveButton,
  isShowSubmitButton,
  isShowPrintButton,
  mdy,
  localTime,
  getSingerTitle,
  statusNotAllowToBeModified,
  objectHash,
} from '../utility/utility'
import swal from 'sweetalert2'

import moment from 'moment'

// printing page design starts from here
const styleOfPrintingForBusinessTravel = {
  // @media print and (orientation: [portrait|landscape]) {}
  '@media print': {
    '@page': {
      margin: '0.5cm',
      orientation: 'Portrait',
    },
    margin: '0.5cm',
  },
  //calc("100% - 1cm") doesn't support? the theme is using it, it can be done somehow for sure
  // 表的宽度完全是受 最宽一行影响的，所以 WIDTH OF TABLE is useless, 一定要注意一行里所有 cell加起来的数值
  page: { width: '100%', marginRight: '0.5cm', marginLeft: '0.5cm', marginTop: '1cm', marginBottom: '1cm' },
  table: { borderCollapse: 'collapse', border: '2px solid black', marginBottom: '15px', tableLayout: 'fixed' }, //
  title: { fontSize: '24px', textAlign: 'center', marginBottom: '20px', fontWeight: 'bold' },
  category: { fontSize: '24px', textAlign: 'center', marginBottom: '30px', fontWeight: 'bold' },
  label: { width: '49mm', border: '1px solid black', fontSize: '15px', textAlign: 'left', fontWeight: 'bold', paddingLeft: '5mm' },
  rs5: { rowSpan: 5 },
  value: { width: '49mm', height: '7mm', border: '1px solid black', paddingLeft: '5mm', wordWrap: 'break-word', wordBreak: 'break-all', textAlign: 'left' },
  numberValue: { width: '45mm', border: '1px solid black', paddingRight: '10mm', wordWrap: 'break-word', wordBreak: 'break-all', textAlign: 'right' },
  requestId: { float: 'left', fontSize: '12px', textAlign: 'left', fontWeight: 'bold', clear: 'right' },
  requestor: { width: '197mm', fontSize: '12px', textAlign: 'right', fontWeight: 'bold' },
  comment: { width: '260mm' },
  signer: { width: '60mm' },
  // signers: { position: "absolute", bottom: 0, pageBreakAfter: "always" }
  signers: { pageBreakAfter: 'always', pageBreakInside: 'avoid' },
}
class printingPageOfBusinessTravel extends React.Component {
  // const defaultPageStyle = pageStyle === undefined
  // ? "@page { size: auto;  margin: 0mm; } @media print { body { -webkit-print-color-adjust: exact; } }"
  // : pageStyle;
  render = () => {
    const { classes, application } = this.props
    const {
      name,
      id,
      creator,
      createdOn,
      departmentName,
      position,
      mobile,
      reason,
      startDate,
      endDate,
      airTicket,
      otherTransports,
      workshop,
      hotel,
      total,
      itineraryDate,
      itineraryFrom,
      itineraryTo,
      itineraryMOT,
      signers,
      lastLevelToSign,
    } = application

    // const signerWidth = signers.length > 0 && signers.length < 5 ? 45 : 258 / signers.length
    const signerWidth = 65
    const itineraryRow = (d, f, t, m) => {
      // date must be converted, otherwise it gives an error
      return (
        <tr>
          <td className={classes.value}>{isNaN(d) ? ' ' : mdy(d)}</td>
          <td className={classes.value}>{isNaN(f) ? ' ' : f}</td>
          <td className={classes.value}>{isNaN(t) ? ' ' : t}</td>
          <td className={classes.value}>{isNaN(m) ? ' ' : m}</td>
        </tr>
      )
    }
    try {
      return (
        <div className={classes.page}>
          <div className={classes.title}>{'Business Travel Application'}</div>
          <div className={classes.requestId}>{'UUID: ' + id.toUpperCase().substr(id.length - 6)} </div>
          <div className={classes.requestor}>{creator ? `${titleCase(creator.name)}, ${localTime(createdOn)}` : ''} </div>
          <table className={classes.table}>
            <tbody>
              <tr>
                <td className={classes.label}>Applicant Name:</td>
                {/* {creator ? `${titleCase(creator.name)}` : ''} */}
                <td className={classes.value}>{name}</td>
                <td className={classes.label}>Department:</td>
                {/* {department.name} */}
                <td className={classes.value}>{departmentName}</td>
              </tr>
              <tr>
                <td className={classes.label}>Position:</td>
                <td className={classes.value}>{position}</td>
                <td className={classes.label}>Mobile #:</td>
                <td className={classes.value}>{mobile}</td>
              </tr>
              <tr>
                <td className={classes.label}>Reason:</td>
                <td className={classes.value} colSpan='3'>
                  {reason}
                </td>
              </tr>
              <tr>
                <td className={classes.label}>Period:</td>
                <td className={classes.value} colSpan='3'>{`From ${mdy(startDate)} to ${mdy(endDate)}`}</td>
              </tr>
              <tr>
                <td colSpan='4'></td>
              </tr>
              <tr>
                <td colSpan='4' className={classes.label}>
                  Itinerary Details{' '}
                </td>
              </tr>
              <tr>
                <td className={classes.label}>Date</td>
                <td className={classes.label}>From</td>
                <td className={classes.label}>To</td>
                <td className={classes.label}>Method of Transportation</td>
              </tr>
              {itineraryRow(itineraryDate[0], itineraryFrom[0], itineraryTo[0], itineraryMOT[0])}
              {itineraryRow(itineraryDate[1], itineraryFrom[1], itineraryTo[1], itineraryMOT[1])}
              {itineraryRow(itineraryDate[2], itineraryFrom[2], itineraryTo[2], itineraryMOT[2])}
              {itineraryRow(itineraryDate[3], itineraryFrom[3], itineraryTo[3], itineraryMOT[3])}
              {itineraryRow(itineraryDate[4], itineraryFrom[4], itineraryTo[4], itineraryMOT[4])}
              <tr>
                <td colSpan='4'></td>
              </tr>
              <tr>
                {/* <td className={classes.label + ' ' + classes.rs5} styles={{ rowspan: '6' }}> */}
                <td rowSpan='6' className={classes.label}>
                  Cost Estimation
                </td>
                <td className={classes.label} colSpan='2'>
                  Items
                </td>
                <td className={classes.label}>Amount</td>
              </tr>
              <tr>
                <td className={classes.label} colSpan='2'>
                  Air Ticket
                </td>
                <td className={classes.numberValue}>{parseFloat(airTicket).toMoney()}</td>
              </tr>
              <tr>
                <td className={classes.label} colSpan='2'>
                  Train/Bus/Car Rental
                </td>
                <td className={classes.numberValue}>{parseFloat(otherTransports).toMoney()}</td>
              </tr>
              <tr>
                <td className={classes.label} colSpan='2'>
                  Conference/Workkshop
                </td>
                <td className={classes.numberValue}>{parseFloat(workshop).toMoney()}</td>
              </tr>
              <tr>
                <td className={classes.label} colSpan='2'>
                  Hotel Accommodation
                </td>
                <td className={classes.numberValue}>{parseFloat(hotel).toMoney()}</td>
              </tr>
              <tr>
                <td className={classes.label} colSpan='2'>
                  Total
                </td>
                <td className={classes.numberValue}>{total}</td>
              </tr>
            </tbody>
          </table>{' '}
          <table className={classes.signers}>
            <tbody>
              <tr>
                {signers.slice(0, lastLevelToSign).map((signer, key) => (
                  <td className={classes.signer} style={{ width: `${signerWidth}mm` }} key={`td${key}`}>
                    {signers ? (
                      // <Signer key={`singer${key}`} signer={{ ...signer, role: signingPath.levels[key] ? signingPath.levels[key].approverGroupName : '' }} />
                      <Signer key={`singer${key}`} signer={{ ...signer, role: signers[key] ? signers[key].approverGroupName : '' }} />
                    ) : (
                      ''
                    )}
                  </td>
                ))}
              </tr>
            </tbody>
          </table>
        </div>
      )
    } catch (error) {
      return `<div>${error}</div>`
    }
  }
}
const BTAPrintPage = withStyles(styleOfPrintingForBusinessTravel)(printingPageOfBusinessTravel)

const initialData = {
  text: {
    title: 'Bussiness Travel Application',
    button: 'Submit',
  },
  data: {
    tableName: 'applications',
    id: '',
    applicant: '',
    name: '',
    departmentName: '',
    position: '',
    cell: '',
    status: 'draft',
    reason: '',
    signers: [],
    startDate: moment().format('YYYY-MM-DD'),
    endDate: moment().format('YYYY-MM-DD'),
    itineraryDate: [],
    itineraryFrom: [],
    itineraryTo: [],
    itineraryMOT: [],
    airTicket: 0,
    otherTransports: 0,
    workshop: 0,
    hotel: 0,
    total: 0,
    days: 0,
    // -1 means for non-saved document, becomes 1 after submition, means the initiator has signed
    activeStep: -1,
    lastLevelToSign: -1, // always assume the initiator will sign first as the first step
  },
  dataState: {},
  // 这个临界值应该从数据库获得，这样用户不需要reload浏览器， 这样不用条件路由，但是不能随意改， 而且有两个assumption
  //  1。 平常用户需要少签一个节点 或者 所有公司的签字路径一样长
  //  2.  每个用户隶属于一个公司， 每个公司有一个路径

  weight_for_regular_users: 50,
}
const fieldsToHash = [
  'id',
  'applicant',
  'creatorId',
  'reason',
  'signers',
  'startDate',
  'endDate',
  'itineraryDate',
  'itineraryFrom',
  'itineraryTo',
  'itineraryMOT',
  'airTicket',
  'otherTransports',
  'workshop',
  'hotel',
]
class BusinessTravelApplicationTemplate extends React.Component {
  constructor(props) {
    super(props)

    this.state = initialData

    this.saveApplication = this.saveApplication.bind(this)
    this.handleDateChange = this.handleDateChange.bind(this)
    this.handleDropDown = this.handleDropDown.bind(this)
    this.change = this.change.bind(this)
  }

  static contextType = AppContext

  isSubmitted = () => statusNotAllowToBeModified.includes(this.state.data.status)
  isFinished = () => this.state.data.status === 'completed' || this.state.data.status === 'rejected'

  handleDateChange = (id, index) => (date) => {
    const { data } = this.state
    if (index < 0) {
      data[id] = date.toDate()
    } else {
      data[id][index] = date.toDate()
    }
    this.setState({ data })
  }
  change = (id, index = -1) => (event) => {
    const { data } = this.state
    if (index < 0) {
      data[id] = event.target.value
      const { airTicket, otherTransports, workshop, hotel } = data
      data['total'] = (parseFloat(airTicket) + parseFloat(otherTransports) + parseFloat(workshop) + parseFloat(hotel)).toMoney()
    } else {
      data[id][index] = event.target.value
    }
    // data[event.target.id] = event.target.value
    // data['days'] = parseInt(dayDiff(data.startDate, data.endDate))
    // const calculatedLastLevel = await getHighestLevelOfSingers(data)
    // if no error, update
    // data['lastLevelToSign'] = calculatedLastLevel > -2 ? calculatedLastLevel : data['lastLevelToSign']
    logger('BusinessTravel: change', data)
    this.setState({ data })
  }
  handleDropDown = (id) => (event) => {
    // console.log({ id, event })
    const { data } = this.state
    data[id] = event
    if (id === 'applicant') {
      const { value: initiatorId, company, weight, departmentName, position } = this.state.data.applicant
      data['departmentName'] = departmentName
      data['position'] = position
      this.loadPathInfo(initiatorId, company, weight)
    }
    this.setState({ data })
  }
  async loadPathInfo(initiatorId, company, weight) {
    // const {
    //   initiatorId,
    //   data: { company }
    // } = this.state
    // const { value: initiatorId, company, weight } = this.state.data.applicant

    if (isEmpty(company) || isEmpty(company.id)) {
      logger(logger('[BusinessTravel][loadPathInfo]', this.state.data))
      return
    }
    const {
      data: { pathBinding },
    } = await retrieveBoundPath({ typeOfApplicationId: 2, companyId: company.id })

    // 2) resolve signers
    if (isEmpty(pathBinding)) {
      // this is not an error, just means no routes yet
      this.setState({
        data: {
          ...this.state.data,
          routes: [],
          signers: [],
        },
      })

      swal.fire({
        title: 'No signing path found!',
        html: `There is no signing path designed for Business Travel Application in <b>[${company.name}]</b> , please have your administrator to construct signing path first please.`,
        type: 'warning',
      })
    } else {
      logger('[BusinessTravel][loadPathInfo]', pathBinding)
      let signers = await signerResolver(pathBinding[0].signingPath, initiatorId)
      let lastLevelToSign = -1
      const levelsOfManager = await getLastLevelOfSingerBasedUponWeight(this.state.data.applicant.weight, signers.length)

      const HRSigner = isEmpty(this.state.data.applicant.company.country) ? [] : await getLastSignerForTOABTA('HR-' + this.state.data.applicant.company.country)
      logger('[TOA][loadPathInfo][2]', { signers, HRSigner, levelsOfManager, lastLevelToSign })
      if (isEmpty(HRSigner)) {
        lastLevelToSign = levelsOfManager
      } else {
        lastLevelToSign = levelsOfManager + 1
        signers.splice(levelsOfManager)
        const { id, position = '', name: fullName, email } = HRSigner
        signers.push({ id, level: lastLevelToSign, position, fullName, email, approverGroupName: 'HR-' + this.state.data.applicant.company.country })
      }

      this.setState({
        data: {
          ...this.state.data,
          // lastLevelToSign: weight >= this.state.weight_for_regular_users ? signers.length : signers.length - 1,
          lastLevelToSign: getLastLevelOfSingerBasedUponWeight(this.state.data.applicant.weight, signers.length),
          signers,
          signingPathId: pathBinding[0].signingPath.id,
          signingPath: pathBinding[0].signingPath,
        },
      })
    }
  }

  loadApplicationDetail = async (id) => {
    const query = `
    query BusinessTravel($id: ID!){
      application(id: $id) {
        id
        creatorId
        creator{
          id
          name
          email
          company{
            id
            name
            country
          }
        }
        createdOn
        lastModifiedOn
        name
        departmentName
        position
        cell
        status
        reason
        signers {
          id
          level
          position
          fullName
          chineseName
          action
          email
          signedOn
        }
        signingPath{
          levels{
            approverGroupName
          }
        }
        startDate
        endDate
        itineraryDate
        itineraryFrom
        itineraryTo
        itineraryMOT
        airTicket
        otherTransports
        workshop
        hotel
        total
        days
        activeStep
        lastLevelToSign
        type {
          id
          name
          description
          short
        }
      }
    }
  `
    await retrieveDataUsingGraphQL(query, { id })
      .then(async (response) => {
        if (response.status === 200) {
          return response.json()
        } else {
          throw new Error(JSON.stringify(await response.json()))
        }
      })
      .then(({ data }) => {
        if (isEmpty(data)) throw new Error('Unable to fetch application details.')
        // Based upon the application type, load data accordingly
        logger('[BusinessTravel][loadApplicationDetail]:', data)
        // this.parseApplicationData(data)
        const { itineraryDate, creator, name, ...rest } = data.application
        this.setState({
          text: {
            title: 'BusinessTravel Application',
          },
          initiatorId: creator.id,
          data: {
            ...this.state.data,
            name,
            creator,
            applicant: {
              label: name,
              value: creator.id,
              country: creator.company.country,
            },
            itineraryDate: itineraryDate.map((d) => moment(d)),
            ...rest,
          },
        })
      })
      .catch((e) => {
        logger('[BusinessTravel][loadApplicationDetail]:', e, true)
        swal.fire({ title: 'Error', html: e.message, type: 'error' }).then((v) => this.props.history.push('/dashboard'))
      }) //error report
  }
  componentWillUnmount() {
    this.context.applicationId = ''
  }
  //pick up all the predefined conditional fields, the key should align with
  async componentDidMount() {
    // console.log(this.context.user)
    let query
    let variables
    let initiatorId = this.context.user ? this.context.user.id : ''

    if (this.props.match.params.id) {
      //this await is necessary, otherwise the activeStep in next step will be unavailable
      await this.loadApplicationDetail(this.props.match.params.id)
      // console.log(this.state.data)
    }
    if (isEmpty(this.state.data.id) || this.state.data.activeStep < 0) {
      // see BTA for logic
      query = `
        query typeOfApplication($id: Int!){
          typeOfApplication(id: $id) {
            id
            name
            description
            short
          }
        }
      `
      variables = { id: 2 }
      await retrieveDataUsingGraphQL(query, variables)
        .then((response) => response.json())
        .then(({ data }) => {
          let   departmentName

          if (isEmpty(this.context.user.department)) {
            logger('[BAT][retrieveDataUsingGraphQL][1]', `Missing department info for ${this.context.user.fullName}.`, true)
          } else {
            // departmentId = this.context.user.department.id
            departmentName = this.context.user.department.name
          }
          const { id, name, position, cell, company, weight } = this.context.user
          this.setState({
            text: {
              title: 'BusinessTravel Application',
            },
            initiatorId,
            data: {
              ...this.state.data,
              type: data.typeOfApplication,
              name,
              applicant: {
                label: name,
                value: id,
                company,
                weight,
              },
              position: isEmpty(position) ? '' : position.name,
              cell,
              company,
              departmentName,
            },
          })
        })
        .catch((e) => {
          logger('[BAT][componentDidMount] - ', e.message, true)
        })
      if (isEmpty(this.state.data.signers)) {
        const { value: initiatorId, company, weight } = this.state.data.applicant
        await this.loadPathInfo(initiatorId, company, weight)
      }
    }
    // get hash code
    this.setState({
      isHRAdmin: await isUserInGroup(this.context.user.id, 'SYSTEM-HR'),
      hash: objectHash(pick(this.state.data, fieldsToHash)),
    })
  }

  saveApplication(isSubmitApplication) {
    try {
      if (isSubmitApplication && isEmpty(this.state.data.signers)) throw new Error('Submission failed, no any signers available.')
      if (true) {
        //noError(this.state.dataState
        const { data } = this.state
        const {
          // remove the following before save,
          routes,
          creator,
          days,
          signingPath,
          signingPathId,
          applicant,
          // modify the following before save
          name,
          signers,
          creatorId,
          // keep the rest
          lastLevelToSign,
          ...keptData
        } = data

        const dataToSave = {
          signers: (() => {
            //check if all the signers exist only when submit
            if (isSubmitApplication) {
              if (isEmpty(signers)) {
                throw new Error('Does not know how to route this applicaiton yet, please consult your administrator.')
              } else if (
                signers.slice(0, lastLevelToSign - 1).reduce((agg, signer) => {
                  return agg || isEmpty(signer.id)
                }, false)
              ) {
                throw new Error(
                  'Missing a signer currently, it might be caused by temprarily no one available in a department or group or due to some system settings, please make your administrator be aware of this situation, it might be better just to take a screenshot to email to them.'
                )
              } else {
                return signers
              }
            }
          })(), // only save signers when isSubmitApplication
          lastLevelToSign,
          ...keptData,
          archived: false,
          //prevent someone else override the original initiator
          name: applicant.label,
          creatorId: isEmpty(creatorId) ? applicant.value : creatorId,
        }
        logger('[BAT][saveApplication]:', dataToSave)
        const insertOrModify = data.id && data.id !== '' ? updateOne : insertOne

        // feels like the first then() and catch() could be moved into general service
        insertOrModify(dataToSave)
          .then((response) => {
            if (response.ok) {
              return response.json()
            } else swal.fire({ title: 'Error', html: response.url, type: 'error' })
          })
          .then(async (res) => {
            //  logger('BTA: saveApplication',res)
            const { id } = res
            const recordId = id ? id : this.state.data.id
            // const creatorName = titleCase(this.context.user.firstname + ' ' + this.context.user.lastname)
            // const creator = { id: this.context.user.id, name: creatorName, email: this.context.user.email }
            // await swal.fire({ title: 'Success', html: 'This record has beend saved - ' + recordId, timer: 2000, type: 'success' })
            if (isSubmitApplication) {
              submitApplication({
                application: { ...this.state.data, id, creator, submitter: creator.id === this.context.user.id ? '' : this.context.user.name },
              }).then(async (data) => {
                logger('[BTA][saveApplication]:', { data })

                if (data.code !== 0) {
                  swal.fire({ title: 'Error', html: data.message, type: 'error' })
                } else {
                  await this.loadApplicationDetail(recordId)
                  await swal.fire({ title: 'Success', html: 'This record has beend submitted - ' + recordId, timer: 2000, type: 'success' })
                  this.setState({
                    hash: objectHash(pick(this.state.data, fieldsToHash)),
                  })
                }
              })
            } else {
              // only show save success message for saving draft, so just 1 message per action
              await swal.fire({ title: 'Success', html: 'This record has beend saved - ' + recordId, timer: 2000, type: 'success' })
              await this.loadApplicationDetail(recordId)
              // load 要把 stataus, creator info 加回来

              const data = {
                ...this.state.data,
                signers,
              }
              this.setState({
                data,
                hash: objectHash(pick(data, fieldsToHash)),
              })
            }
          })
        // .catch(e => swal('Error', `General API throw error: ${e}`), 'error')
      } else {
        // swal('Error', 'Please fix the error or fill in all the mandatory fields.', 'error')
        throw new Error('Please fix the error or fill in all the mandatory fields.')
      }
    } catch (e) {
      logger('BusinessTravel: saveApplication', e, true)
      swal.fire({ title: 'Error', html: e.message, type: 'error' })
    }
  }

  render() {
    const { classes } = this.props
    const getCornerInfo = () =>
      !isEmpty(this.state.data.id)
        ? `UUID: ${this.state.data.id.toUpperCase().substr(this.state.data.id.length - 6)} [${titleCase(this.state.data.creator.name)}]`
        : ''
    const maxLengthOfItinerary = 30
    const textInput = (id, index, maxLength) => {
      return (
        <TextField
          id={id}
          type='text'
          disabled={this.isSubmitted()}
          value={index > -1 ? (isEmpty(this.state.data[id][index]) ? '' : this.state.data[id][index]) : this.state.data[id]}
          className={classes.textField}
          onChange={this.change(id, index)}
          InputLabelProps={{
            shrink: true,
          }}
          inputProps={{
            maxLength: maxLength,
          }}
          // 这个太搞笑了，浪费时间啊
          // InputProps={{
          //   disableUnderline: true
          // }}
        />
      )
    }

    const dateInput = (id, index) => {
      return (
        <MuiPickersUtilsProvider utils={MomentUtils}>
          <DatePicker
            //inputProps={{ style: { marginLeft: '35px' } }} #hange input style inside div
            style={{ marginLeft: '15px' }}
            disableToolbar
            variant='inline'
            format='MM/DD/YYYY'
            // label='date'
            disabled={this.isSubmitted()}
            placeholder='MM/DD/YYYY'
            value={index > -1 ? (isNaN(this.state.data[id][index]) ? null : this.state.data[id][index]) : this.state.data[id]}
            autoOk={true}
            onChange={this.handleDateChange(id, index)}
          />
        </MuiPickersUtilsProvider>
      )
    }

    const moneyInput = (id, disabled = false) => {
      return (
        <CustomMoneyInput
          id={id}
          formControlProps={{
            fullWidth: true,
          }}
          disabled={disabled || this.isSubmitted()}
          onChange={this.change(id, -1)}
          inputProps={{
            // onChange: event => this.change('airTicket', -1),
            onChange: this.change(id, -1),
            value: this.state.data[id],
            type: 'text',
          }}
        />
      )
    }
    return (
      <div>
        <GridContainer>
          <GridItem xs={12}>
            <Card>
              <CardHeader color='rose' icon>
                <CardIcon color='rose'>
                  <LocalLibrary />
                </CardIcon>
                <h4 className={classes.cardIconTitle}>{this.state.text.title}</h4>
              </CardHeader>
              <CardBody>
                <form>
                  <GridContainer>
                    {/** row 1   */}
                    <GridItemCondense xs={12} md={2}>
                      <FormLabel className={classes.labelCondense}>Name</FormLabel>
                    </GridItemCondense>
                    <GridItemCondense xs={12} md={4}>
                      <DropdownUsers
                        id='applicant'
                        isDisabled={this.isSubmitted() || !this.state.isHRAdmin}
                        value={this.state.data.applicant}
                        onChange={this.handleDropDown('applicant')}
                      />
                    </GridItemCondense>
                    <GridItemCondense xs={12} md={2}>
                      <FormLabel className={classes.labelCondense}>Department:</FormLabel>
                    </GridItemCondense>
                    <GridItemCondense xs={12} md={4}>
                      <CustomInputCondense
                        id='department'
                        disabled={true}
                        formControlProps={{
                          fullWidth: true,
                        }}
                        inputProps={{
                          value: this.state.data.departmentName,
                          type: 'text',
                        }}
                      />
                    </GridItemCondense>
                    {/** row 2   */}
                    <GridItemCondense xs={12} md={2}>
                      <FormLabel className={classes.labelCondense}>Position</FormLabel>
                    </GridItemCondense>
                    <GridItemCondense xs={12} md={4}>
                      <CustomInputCondense
                        id='position'
                        disabled={true}
                        formControlProps={{
                          fullWidth: true,
                        }}
                        inputProps={{
                          value: this.state.data.position,
                          type: 'text',
                        }}
                      />
                    </GridItemCondense>
                    <GridItemCondense xs={12} md={2}>
                      <FormLabel className={classes.labelCondense}>Mobile #</FormLabel>
                    </GridItemCondense>
                    <GridItemCondense xs={12} md={4}>
                      <CustomInputCondense
                        id='cell'
                        disabled={true}
                        formControlProps={{
                          fullWidth: true,
                        }}
                        inputProps={{
                          value: isEmpty(this.state.data.cell) ? '' : this.state.data.cell,
                          type: 'text',
                        }}
                      />
                    </GridItemCondense>
                    {/** row 3   */}
                    <GridItemCondense xs={12} md={2}>
                      <FormLabel className={classes.labelCondense}>Reason</FormLabel>
                    </GridItemCondense>
                    <GridItemCondense xs={12} md={10}>
                      {/* {textInput('reason', -1, 60)} */}
                      <CustomInputCondense
                        id='reason'
                        disabled={this.isSubmitted()}
                        formControlProps={{
                          fullWidth: true,
                        }}
                        inputProps={{
                          value: this.state.data.reason,
                          onChange: this.change('reason', -1),
                          type: 'text',
                        }}
                      />
                    </GridItemCondense>
                    {/** row 4   */}
                    <GridItemCondense xs={12} md={2}>
                      <FormLabel className={classes.labelCondense}>Start Date</FormLabel>
                    </GridItemCondense>
                    <GridItemCondense xs={12} md={4}>
                      {dateInput('startDate', -1)}
                    </GridItemCondense>
                    <GridItemCondense xs={12} md={2}>
                      <FormLabel className={classes.labelCondense}>End Date</FormLabel>
                    </GridItemCondense>
                    <GridItemCondense xs={12} md={4}>
                      {dateInput('endDate', -1)}
                    </GridItemCondense>
                    {/** row 5   */}
                    <GridItemCondense xs={12} md={2}>
                      <FormLabel className={classes.labelCondense}>Itinerary Details</FormLabel>
                    </GridItemCondense>
                    <GridItemCondense xs={12} md={10}>
                      <FormLabel className={classes.labelCondense}></FormLabel>
                    </GridItemCondense>
                    {/** row 6   */}
                    <GridItemCondense xs={12} md={2}>
                      <FormLabel className={classes.labelCondense}></FormLabel>
                    </GridItemCondense>
                    <GridItemCondense xs={12} md={2}>
                      <CustomInputCondense disabled={true} inputProps={{ value: 'Date' }}></CustomInputCondense>
                    </GridItemCondense>
                    <GridItemCondense xs={12} md={2}>
                      <CustomInputCondense disabled={true} inputProps={{ value: 'From' }}></CustomInputCondense>
                    </GridItemCondense>
                    <GridItemCondense xs={12} md={2}>
                      <CustomInputCondense disabled={true} inputProps={{ value: 'To' }}></CustomInputCondense>
                    </GridItemCondense>
                    <GridItemCondense xs={12} md={2}>
                      <CustomInputCondense disabled={true} inputProps={{ value: 'Methods of Transportation' }}></CustomInputCondense>
                    </GridItemCondense>
                    <GridItemCondense xs={12} md={2}>
                      <FormLabel className={classes.labelCondense}></FormLabel>
                    </GridItemCondense>
                    {/** row 7   */}
                    <GridItemCondense xs={12} md={2}>
                      <FormLabel className={classes.labelCondense}></FormLabel>
                    </GridItemCondense>
                    <GridItemCondense xs={12} md={2}>
                      {dateInput('itineraryDate', 0)}
                    </GridItemCondense>
                    <GridItemCondense xs={12} md={2}>
                      {textInput('itineraryFrom', 0, maxLengthOfItinerary)}
                    </GridItemCondense>
                    <GridItemCondense xs={12} md={2}>
                      {textInput('itineraryTo', 0, maxLengthOfItinerary)}
                    </GridItemCondense>
                    <GridItemCondense xs={12} md={2}>
                      {textInput('itineraryMOT', 0, maxLengthOfItinerary)}
                    </GridItemCondense>
                    <GridItemCondense xs={12} md={2} />
                    {/** row 8   */}{' '}
                    <GridItemCondense xs={12} md={2}>
                      <FormLabel className={classes.labelCondense}></FormLabel>
                    </GridItemCondense>
                    <GridItemCondense xs={12} md={2}>
                      {dateInput('itineraryDate', 1)}
                    </GridItemCondense>
                    <GridItemCondense xs={12} md={2}>
                      {textInput('itineraryFrom', 1, maxLengthOfItinerary)}
                    </GridItemCondense>
                    <GridItemCondense xs={12} md={2}>
                      {textInput('itineraryTo', 1, maxLengthOfItinerary)}
                    </GridItemCondense>
                    <GridItemCondense xs={12} md={2}>
                      {textInput('itineraryMOT', 1, maxLengthOfItinerary)}
                    </GridItemCondense>
                    <GridItemCondense xs={12} md={2} />
                    {/** row 9   */}{' '}
                    <GridItemCondense xs={12} md={2}>
                      <FormLabel className={classes.labelCondense}></FormLabel>
                    </GridItemCondense>
                    <GridItemCondense xs={12} md={2}>
                      {dateInput('itineraryDate', 2)}
                    </GridItemCondense>
                    <GridItemCondense xs={12} md={2}>
                      {textInput('itineraryFrom', 2, maxLengthOfItinerary)}
                    </GridItemCondense>
                    <GridItemCondense xs={12} md={2}>
                      {textInput('itineraryTo', 2, maxLengthOfItinerary)}
                    </GridItemCondense>
                    <GridItemCondense xs={12} md={2}>
                      {textInput('itineraryMOT', 2, maxLengthOfItinerary)}
                    </GridItemCondense>
                    <GridItemCondense xs={12} md={2} />
                    {/** row 10   */}{' '}
                    <GridItemCondense xs={12} md={2}>
                      <FormLabel className={classes.labelCondense}></FormLabel>
                    </GridItemCondense>
                    <GridItemCondense xs={12} md={2}>
                      {dateInput('itineraryDate', 3)}
                    </GridItemCondense>
                    <GridItemCondense xs={12} md={2}>
                      {textInput('itineraryFrom', 3, maxLengthOfItinerary)}
                    </GridItemCondense>
                    <GridItemCondense xs={12} md={2}>
                      {textInput('itineraryTo', 3, maxLengthOfItinerary)}
                    </GridItemCondense>
                    <GridItemCondense xs={12} md={2}>
                      {textInput('itineraryMOT', 3, maxLengthOfItinerary)}
                    </GridItemCondense>
                    <GridItemCondense xs={12} md={2} />
                    {/** row 11   */}
                    <GridItemCondense xs={12} md={2}>
                      <FormLabel className={classes.labelCondense}></FormLabel>
                    </GridItemCondense>
                    <GridItemCondense xs={12} md={2}>
                      {dateInput('itineraryDate', 4)}
                    </GridItemCondense>
                    <GridItemCondense xs={12} md={2}>
                      {textInput('itineraryFrom', 4, maxLengthOfItinerary)}
                    </GridItemCondense>
                    <GridItemCondense xs={12} md={2}>
                      {textInput('itineraryTo', 4, maxLengthOfItinerary)}
                    </GridItemCondense>
                    <GridItemCondense xs={12} md={2}>
                      {textInput('itineraryMOT', 4, maxLengthOfItinerary)}
                    </GridItemCondense>
                    <GridItemCondense xs={12} md={2} />
                    {/** cost estimates   */}
                    <GridItemCondense xs={12} md={2}>
                      <FormLabel className={classes.labelCondense}>Cost Estimates</FormLabel>
                    </GridItemCondense>
                    <GridItemCondense xs={12} md={10}>
                      <FormLabel className={classes.labelCondense}></FormLabel>
                    </GridItemCondense>
                    {/* <GridItemCondense xs={12} md={2}>
                      <FormLabel className={classes.labelCondense}></FormLabel>
                    </GridItemCondense>
                    <GridItemCondense xs={12} md={2}>
                      <CustomInputCondense disabled={true} inputProps={{ value: 'Item' }}></CustomInputCondense>
                    </GridItemCondense>
                    <GridItemCondense xs={12} md={2}>
                      <CustomInputCondense disabled={true} inputProps={{ value: 'Amount' }}></CustomInputCondense>
                    </GridItemCondense>
                    <GridItemCondense xs={12} md={6}>
                      <FormLabel className={classes.labelCondense}></FormLabel>
                    </GridItemCondense> */}
                    {/* cost estimate row 1 */}
                    <GridItemCondense xs={12} md={2}>
                      <FormLabel className={classes.labelCondense}>Air Ticket</FormLabel>
                    </GridItemCondense>
                    <GridItemCondense xs={12} md={2}>
                      {moneyInput('airTicket')}
                    </GridItemCondense>
                    <GridItemCondense xs={12} md={2}>
                      <FormLabel className={classes.labelCondense}>Train/Bus/Car Rental</FormLabel>
                    </GridItemCondense>
                    <GridItemCondense xs={12} md={2}>
                      {moneyInput('otherTransports')}
                    </GridItemCondense>
                    <GridItemCondense xs={12} md={4} />
                    {/* cost estimate row 2 */}
                    <GridItemCondense xs={12} md={2}>
                      <FormLabel className={classes.labelCondense}>Conference/Workshop</FormLabel>
                    </GridItemCondense>
                    <GridItemCondense xs={12} md={2}>
                      {moneyInput('workshop')}
                    </GridItemCondense>
                    <GridItemCondense xs={12} md={2}>
                      <FormLabel className={classes.labelCondense}>Hotel Accommodation</FormLabel>
                    </GridItemCondense>
                    <GridItemCondense xs={12} md={2}>
                      {moneyInput('hotel')}
                    </GridItemCondense>
                    <GridItemCondense xs={12} md={4} />
                    {/* cost estimate row 3 */}
                    <GridItemCondense xs={12} md={2}>
                      <FormLabel className={classes.labelCondense}>Total</FormLabel>
                    </GridItemCondense>
                    <GridItemCondense xs={12} md={2}>
                      {moneyInput('total', true)}
                    </GridItemCondense>
                    <GridItemCondense xs={12} md={8} />
                    {/** line of singers */}
                    {this.state.data.signers
                      .sort((a, b) => a.level - b.level)
                      .map((signer, key) =>
                        signer.level <= this.state.data.lastLevelToSign ? (
                          <GridItem key={`singer-grid${key}`} xs={3} md={2}>
                            <Signer
                              key={`singer${key}`}
                              signer={{
                                ...signer,
                                role: getSingerTitle(signer, key, this.state.data.signingPath),
                              }}
                            />
                          </GridItem>
                        ) : (
                          ''
                        )
                      )}
                  </GridContainer>
                </form>
              </CardBody>
              <CardActions className={classes.actions}>
                <FormLabel className={classes.labelCondense}>{getCornerInfo()}</FormLabel>
                {isShowSaveButton(pick(this.state.data, fieldsToHash), this.context.user.id, this.state.hash) ? (
                  <Button color='rose' style={{ marginLeft: 'auto' }} onClick={() => this.saveApplication(false)}>
                    Save
                  </Button>
                ) : (
                  ''
                )}

                {isShowSubmitButton(this.state.data, this.context.user.id, this.state.isHRAdmin) ? (
                  <Button
                    color='rose'
                    style={isShowSaveButton(pick(this.state.data, fieldsToHash), this.context.user.id, this.state.hash) ? {} : { marginLeft: 'auto' }}
                    onClick={() => this.saveApplication(true)}
                  >
                    Submit
                  </Button>
                ) : (
                  ''
                )}
                {/* 同意/拒绝按钮 */}
                {isShowActionButtons(this.state.data, this.context.user.id) ? (
                  <Fragment>
                    <Button
                      color='rose'
                      style={{ marginLeft: 'auto' }}
                      onClick={() =>
                        handleApprove({ application: this.state.data, refresh: this.loadApplicationDetail, pullingNumbers: this.context.pullingNumbers })
                      }
                    >
                      Approve
                    </Button>
                    <Button
                      color='rose'
                      onClick={() =>
                        handleReject({ application: this.state.data, refresh: this.loadApplicationDetail, pullingNumbers: this.context.pullingNumbers })
                      }
                    >
                      Reject
                    </Button>
                  </Fragment>
                ) : (
                  ''
                )}
                {/* 打印按钮 */}
                {this.state.data.id !== '' ? (
                  <ReactToPrint
                    trigger={() => (
                      <Button
                        color='rose'
                        // style={isShowSaveButton(pick(this.state.data, fieldsToHash), this.context.user.id, this.state.hash) ? {} : { marginLeft: 'auto' }}
                        // className={['rejected', 'completed', 'submitted'].includes(this.state.data.status) ? classes.buttons : ''}
                        style={
                          isShowPrintButton(pick(this.state.data, fieldsToHash), this.context.user.id, this.state.hash)
                            ? { marginLeft: 'auto' }
                            : { marginLeft: 'unset' }
                        }
                        // onClick={() => handlePrint({ application: this.state.data })}
                      >
                        Print
                      </Button>
                    )}
                    content={() => this.componentRef}
                    pageStyle='@page { size: auto;  margin: 5mm; }'
                  />
                ) : (
                  ''
                )}
              </CardActions>
            </Card>
          </GridItem>
          <div style={{ display: 'none' }}>
            <BTAPrintPage application={this.state.data} ref={(el) => (this.componentRef = el)} />
          </div>
        </GridContainer>
        {jsonPP(this.context)}
        {jsonPP(this.state)}
        {/* {objectHash(pick(this.state.data, fieldsToHash))} */}
      </div>
    )
  }
}

export default withStyles(requestSubContractorPayment, { withTheme: true })(BusinessTravelApplicationTemplate)
